
export const pageTitleDefault = `Voilacatalog`;
export const pageTitleAbout = `Voilacatalog | About`;


// WEBPACK FOOTER //
// ./src/constants.js